import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgCa48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Canada",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#de2910",
  d: "M2 12a10 10 0 0 0 3.53 7.64V4.36A10 10 0 0 0 2 12m20 0a10.5 10.5 0 0 0-3.53-7.63v15.26A10.5 10.5 0 0 0 22 12M12 6.18l-1 1.75c-.1.19-.3.18-.49.06l-.68-.35.5 2.7c.1.49-.24.49-.4.28L8.76 9.28l-.19.72a.25.25 0 0 1-.26.17l-1.5-.32.39 1.44c.09.31.15.45-.09.53l-.52.18 2.57 2.11a.33.33 0 0 1 .11.35l-.22.75c.89-.1 1.68-.26 2.57-.36.08 0 .22.13.22.22l-.12 2.72h.43l-.06-2.71c0-.09.11-.23.2-.21.89.1 1.68.25 2.57.35l-.22-.75a.34.34 0 0 1 .11-.35L17.33 12l-.53-.25c-.24-.09-.16-.21-.09-.53l.39-1.44-1.49.32a.24.24 0 0 1-.27-.17l-.19-.68L14 10.63c-.19.2-.54.2-.42-.29l.5-2.7-.71.36c-.19.1-.38.13-.49-.06z"
}));

export { SvgCa48Rounded as default };
//# sourceMappingURL=Ca48Rounded.js.map
